import { Injectable, signal } from '@angular/core';

import { AppLanguage, LanguageOption } from './i18n.models';
import { TRANSLATIONS } from './i18n.translations';

const STORAGE_KEY = 'clinic-web.language';

@Injectable({ providedIn: 'root' })
export class I18nService {
  private readonly languageSignal = signal<AppLanguage>(this.readInitialLanguage());

  public readonly languages: LanguageOption[] = [
    { code: 'en', label: 'EN' },
    { code: 'ro', label: 'RO' },
    { code: 'ru', label: 'RUS' }
  ];

  public constructor() {
    document.documentElement.lang = this.languageSignal();
  }

  public get language(): AppLanguage {
    return this.languageSignal();
  }

  public setLanguage(language: AppLanguage): void {
    this.languageSignal.set(language);
    localStorage.setItem(STORAGE_KEY, language);
    document.documentElement.lang = language;
  }

  public translate(key: string): string {
    const current = TRANSLATIONS[this.languageSignal()];
    const english = TRANSLATIONS.en;

    return current[key] ?? english[key] ?? key;
  }

  private readInitialLanguage(): AppLanguage {
    const stored = localStorage.getItem(STORAGE_KEY);

    if (stored === 'en' || stored === 'ro' || stored === 'ru') {
      return stored;
    }

    return 'en';
  }
}
